import React from 'react'
import InnerServiceAreaTwoItem from './InnerServiceAreaTwoItem'
import InnerServicesAreaItem from './InnerServicesAreaItem';

function InnerServiceAre() {
  const services = [
    {
      src: "/img/custom-icons/1.png",
      url: "/services/logo-design",
      title: "Logo Design",
      desc: "Crafting a timeless logo is more than just a creative exercise—it’s a strategic process that lays the foundation for your brand’s identity. By understanding your brand’s essence, focusing on simplicity and versatility, and following classic design principles, you can create a logo that stands the test of time.",
    },
    {
      src: "/img/custom-icons/2.png",
      url: "/services/web-design",
      title: "Web Designing",
      desc: "We specialize in crafting websites that not only inspire creativity but also captivate audiences and drive meaningful digital success. By blending innovative design with user-centric functionality, we create online experiences that engage visitors, foster connections, and deliver results.",
    },
    {
      src: "/img/custom-icons/3.png",
      url: "/contact",
      title: "Brand Design",
      desc: "We specialize in shaping bold, impactful identities that tell your brand’s unique story with clarity and confidence. By crafting a distinctive visual language and a compelling narrative, we help you stand out in a crowded market Our approach ensures that every element—from logo.",
    },
    {
      src: "/img/custom-icons/4.png",
      url: "/services/package-design",
      title: "Packaging Design",
      desc: "We create innovative packaging that not only speaks volumes about your brand but also delights and engages your customers. Our designs combine creativity, functionality, and sustainability to deliver packaging that captures attention and enhances the unboxing experience By focusing on the finer.",
    },
    {
      src: "/img/custom-icons/5.png",
      url: "/contact",
      title: "UI/UX Design",
      desc: "We design intuitive, user-centric experiences that engage audiences and elevate digital interfaces to new heights. By seamlessly blending form and function, we create interfaces that are not only visually appealing but also easy to navigate, ensuring a smooth and enjoyable user journey.",
    },
    {
      src: "/img/custom-icons/6.png",
      url: "/contact",
      title: "Business Advertising",
      desc: "We focus on maximizing your brand's visibility, driving sustainable growth, and amplifying its reach across multiple platforms. By leveraging data-driven strategies and creative approaches, we ensure your brand not only stands out but also connects with the right audience at the right time.",
    },
    {
      src: "/img/custom-icons/7.png",
      url: "/services/seo",
      title: "SEO",
      desc: "We specialize in boosting your online presence through results-driven SEO strategies that drive organic traffic and improve search engine rankings. By utilizing the latest SEO techniques and data-driven insights, we optimize every aspect of your website to ensure it attracts the right audience.",
    },
    {
      src: "/img/custom-icons/8.png",
      url: "/contact",
      title: "Brand Strategy",
      desc: "We specialize in crafting strategic solutions that position your brand for long-term success and sustainable growth. By analyzing market trends, understanding your audience, and aligning with your brand’s core values, we develop tailored strategies that create a strong foundation for the future.",
    },
    {
      src: "/img/custom-icons/9.png",
      url: "/contact",
      title: "PPC",
      desc: "We drive immediate results through highly targeted PPC campaigns designed to maximize ROI and enhance your brand's visibility. By leveraging data-driven insights and strategic ad placements, we ensure your campaigns reach the right audience at the right time, delivering optimal performance.",
    },
    {
      src: "/img/custom-icons/10.png",
      url: "/contact",
      title: "Content Writing",
      desc: "We specialize in crafting compelling, high-quality content that not only resonates with your audience but also drives meaningful engagement. By understanding your brand’s voice and audience preferences, we create content that informs, entertains, and inspires action.",
    },
    {
      src: "/img/custom-icons/1.png",
      url: "/contact",
      title: "Social Campaigns",
      desc: "We design dynamic social campaigns that amplify your brand’s voice and actively engage your audience across multiple platforms. By tapping into current trends, crafting captivating content, and leveraging targeted strategies, we create campaigns that not only capture attention but.",
    },
    {
      src: "/img/custom-icons/6.png",
      url: "/contact",
      title: "Animation",
      desc: "At thedigitalcreativedesigns, animation comes to life with creativity and precision. We craft engaging, visually stunning animations that captivate audiences, tell compelling stories, and elevate brands. Let thedigitalcreativedesigns transform your vision into dynamic, unforgettable animated experiences.",
    },
  ];
    
    return (
        <div className="container mb-40" style={{marginTop: "-70px"}}>
            <div className="inner-services-wrap-two">
            <div className="row justify-content-center">
                {services.map((x, index) => (
                    <div key={index} className="col-xl-4 col-lg-3 col-md-6 col-sm-10">
                        <InnerServicesAreaItem item={x} />
                    </div>
                ))}
            </div>
        </div>
        </div>
        
    )
}

export default InnerServiceAre